
<section class="wrapper-invoice mt-5 mx-2">
    <div class="invoice row">
      <!-- logo brand invoice -->
      <div class="col-md-6 invoice-logo-brand d-flex justify-content-center justify-content-md-start">
        <img src="{{ businessLogo }}" alt="" />
      </div>

      <div class="col-md-6 invoice-logo-brand d-flex justify-content-center justify-content-md-end align-items-center">
        <h1 class="text-uppercase">{{'Sellers.Products.claim' |translate}}</h1>
      </div>
      <hr style="border-top: 3px solid #000;opacity: 1;"/>

      <!-- invoice head -->
      <div class="col-md-9 invoice-head">
        <div class="head client-info">
          <h2>{{ productObject["productName"] }}</h2>
          <p>{{ "Buyer.HostedBy" | translate }} : {{ businessObject?.name }}</p>
          <p>{{ "Buyer.Description" | translate }} :{{ description }}</p>
        </div>
      </div>

      <div class="col-md-3 invoice-information">
        <p>
          <b>{{ "Sellers.Products.claimNumber" | translate }} #</b> {{ claimNumber }}
        </p>
        <p>
          <b>{{ "Buyer.Issued" | translate }}</b> : {{ issuanceDate |  date }}
        </p>
        <p>
          <b>{{ "Buyer.Expires" | translate }}</b> : {{ expiryDate | date }}
        </p>
        <p>
          <b>{{ "Sellers.Products.dueDate" |translate  }}</b> : {{ dueDate |  date }}
      </p>
      </div>

      <!-- invoice body-->
      <div class="col-12 invoice-body table-responsive">
        <table class="table">
          <thead>
            <tr>
              <th>{{ "Sellers.Products.claimItems" | translate }}</th>
              <th>{{ "Buyer.Quantity" | translate }}</th>
              <th>{{ "Buyer.Price" | translate }}</th>
              <th>{{ "Buyer.Amount" | translate }}</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let item of ClaimItems">
              <td class="service">{{ item.Item_Name }}</td>
              <td class="qty">
                {{ item.Quantity >= 0 ? item.Quantity : "N/A" }}
              </td>
              <td class="total">
                {{
                  getExchangedValue(
                    item.Price,
                    getNewProductValueByFieldName("currency", "ProductExtraInfos")
                  ).toFixed(2)
                }}
                {{
                  getNewProductValueByFieldName("currency", "ProductExtraInfos")
                }}
              </td>
              <td class="total">
                {{
                  getExchangedValue(
                    item.Price * item.Quantity,
                    getNewProductValueByFieldName("currency", "ProductExtraInfos")
                  ).toFixed(2)
                }}
                {{
                  getNewProductValueByFieldName("currency", "ProductExtraInfos")
                }}
              </td>
            </tr>
          </tbody>
        </table>
        <!-- invoice total  -->
        <div class="invoice-total-amount text-end">
          <button
            class="btn btn-outline-dark"
            type="button"
            [disabled]="!ClaimItems.length"
            (click)="proceedToPayment()"
          >
          {{'Sellers.Products.pay' |translate}}
          </button>
        </div>
      </div>
      <!-- invoice footer -->
      <div class="invoice-footer">
        <p>{{'Sellers.Products.happy_shopping_again'|translate}}</p>
      </div>
    </div>
  </section>
